/**
 * Prompts for browser geolocation. Returns `"lat, lng"` or null if denied / unsupported.
 */
export function requestGeolocationString(): Promise<string | null> {
  //Not supported by all browsers
  if (typeof navigator === 'undefined' || !navigator.geolocation) {
    return Promise.resolve(null)
  }

  return new Promise(resolve => {
    navigator.geolocation.getCurrentPosition(
      position => {
        const { latitude, longitude } = position.coords
        resolve(`${latitude}, ${longitude}`)
      },
      () => resolve(null),
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0,
      }
    )
  })
}
